import { Page } from "@/types";
import { withCheckoutId } from "@/lib/checkout-id";

const ROUTES_BY_PAGE = new Map<Page, string>([
  [Page.PAYMENT_PLAN_SELECTION, "/"],
  [Page.IVR_CONFIRMATION, "/ivr"],
  [Page.PAYMENT_CONFIRMATION, "/confirmation"],
  [Page.SUCCESS, "/success"],
]);

export const navigateToPage = (
  navigate: (route: string) => void,
  page: Page,
) => {
  if (!ROUTES_BY_PAGE.has(page))
    throw new Error(`Failed to resolve page for redirection: ${page}`);

  navigate(withCheckoutId(ROUTES_BY_PAGE.get(page) ?? ""));
};
